import { Box, Grid, Typography } from "@mui/material";
import { default_Photo } from "../../../../Assets";
import { teamGradients } from "../../../../Utils/helperFunctions";

const PlayerSection: React.FC<any> = ({ teamDetails }) => {
  interface Player {
    soldTo?: string;
    photo: string;
    name?: string;
    soldToLogo?: string;
  }

  interface TransformedPlayer {
    logo: string;
    playerName: string;
    gradient: {
      from: string;
      to: string;
    };
    teamName: string;
    teamLogo?: string;
  }

  const transformedPlayers: TransformedPlayer[] | undefined = teamDetails?.map(
    (player: Player) => {
      const gradient = teamGradients[player?.soldTo || ""] || {
        from: "#444",
        to: "#222",
      };
      return {
        logo: player?.photo,
        playerName: player?.name,
        gradient,
        teamName: player?.soldTo || "",
        teamLogo: player?.soldToLogo,
      };
    },
  );

  return (
    <Box mt={{ xs: 2.4, md: "1.15vw" }}>
      <Grid
        container
        sx={{ width: "100%" }}
        columnSpacing={{ xs: 2, md: "2vw" }}
        rowSpacing={{ xs: 4.8, md: "2.35vw" }}
      >
        {transformedPlayers?.map((item, i) => (
          <Grid
            item
            key={i}
            xs={12}
            sm={6}
            md={4}
            lg={3}
            sx={{ display: "flex" }}
          >
            <PlayerCard data={item} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const PlayerCard: React.FC<any> = ({ data }) => {
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: { xs: 1, md: "0.55vw" },
        px: { xs: 1.2, md: "0.5vw" },
        pb: { xs: 1.2, md: "0.55vw" },
        pt: { xs: 6.6, md: "4.15vw" },
        display: "flex",
        justifyContent: "center",
        background: `linear-gradient(to bottom, ${data.gradient.from}, ${data.gradient.to})`,
        minHeight: { xs: 224, md: "16vw" },
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          zIndex: 3,
          textAlign: "center",
          top: { xs: -32, md: "-1.5vw" },
          backgroundColor: "#fff",
          p: { xs: 0.34, md: "0.18vw" },
          width: { xs: 104, md: "8.5vw" },
          height: { xs: 104, md: "8.5vw" },
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          borderRadius: "999px",
          border: { xs: "3px solid #F47821", md: "0.16vw solid #F47821" },
          overflow: "hidden",
        }}
      >
        <img
          src={data?.logo ?? default_Photo}
          alt="Team Logo"
          width={200}
          height={200}
          style={{
            height: "100%",
            width: "100%",
            margin: "0 auto",
            objectFit: "cover",
          }}
        />
      </Box>
      <Box
        sx={{
          textAlign: "center",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minHeight: "100%",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: { xs: 0.8, md: "0.3vw" },
            py: { xs: 0, md: "0.55vw" },
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "1.7rem", md: "2vw" },
              fontWeight: 700,
              lineHeight: 1.08,
              textAlign: "center",
            }}
            color="white"
          >
            {data?.playerName}
          </Typography>
        </Box>
        {data?.teamName && (
          <Box
            sx={{
              width: "100%",
              color: "#fff",
              display: "flex",
              alignItems: "stretch",
              gap: { xs: 0.8, md: "0.35vw" },
              marginTop: "auto",
              minHeight: { xs: 52, md: "3.15vw" },
              background:
                "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.30) 50%, rgba(255, 255, 255, 0.00) 100%)",
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                p: { xs: 0.45, md: "0.2vw" },
                width: { xs: 58, md: "3.05vw" },
                minWidth: { xs: 58, md: "3.05vw" },
                minHeight: { xs: 52, md: "3.15vw" },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={data?.teamLogo}
                alt={data?.teamName}
                width={100}
                height={100}
                style={{
                  height: "100%",
                  width: "100%",
                  margin: "0 auto",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "0.92rem", md: "1.2vw" },
                fontWeight: 700,
                py: { xs: 0.45, md: "0.28vw" },
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                flex: 1,
                minWidth: 0,
                textAlign: "start",
                width: "auto",
                textTransform: "uppercase",
                lineHeight: 1.05,
                overflowWrap: "break-word",
              }}
              color="white"
            >
              {data?.teamName}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PlayerSection;
